/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import UploadConfig from '../model/UploadConfig';

/**
* Upload service.
* @module api/UploadApi
* @version 1.0.0
*/
export default class UploadApi {

    /**
    * Constructs a new UploadApi. 
    * @alias module:api/UploadApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the getUploadConfig operation.
     * @callback module:api/UploadApi~getUploadConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UploadConfig} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Which metadata set the upload dialog shows and which of its fields are required
     * @param {module:api/UploadApi~getUploadConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UploadConfig}
     */
    getUploadConfig(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = UploadConfig;
      return this.apiClient.callApi(
        '/upload/config', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateUploadConfig operation.
     * @callback module:api/UploadApi~updateUploadConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UploadConfig} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replace the upload metadata configuration
     * @param {module:model/UploadConfig} uploadConfig 
     * @param {module:api/UploadApi~updateUploadConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UploadConfig}
     */
    updateUploadConfig(uploadConfig, callback) {
      let postBody = uploadConfig;
      // verify the required parameter 'uploadConfig' is set
      if (uploadConfig === undefined || uploadConfig === null) {
        throw new Error("Missing the required parameter 'uploadConfig' when calling updateUploadConfig");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = UploadConfig;
      return this.apiClient.callApi(
        '/upload/config', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
